import React from "react";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

class KDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: this.props.showAlert,

    };
    this.handleAlertClose = this.handleAlertClose.bind(this);

    this.title = this.props.title ? this.props.title : 'Information Required'
  }

  getMessageLines() {
    if (this.props.messages === null) {
      return '';
    }
    else {
      return (
        this.props.messages.map((message, index) => (
          <Typography key={index} gutterBottom>
            {message}
          </Typography>
        ))
      )
    }
  }

  handleAlertClose() {
    this.setState((state, props) => {
      return { showAlert: false };
    });
    if (this.props.onAlertClose)
      this.props.onAlertClose();
  }
  render() {
    return (
      <Dialog
        open={this.state.showAlert}
        onClose={this.handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title"> {this.title}</DialogTitle>
        <DialogContent dividers>
          {this.getMessageLines()}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.handleAlertClose} color="primary">
            OK
       </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default KDialog;